module.exports = __webpack_public_path__ + "static/media/chs_3.b6092464.png";